'use client'

import { useTranslations } from 'next-intl'
import Section from '../../layout/section'
import { CustomDataValues } from '../company/custom-data-values'
import { EntrepriseCustomDataSetting } from '../../../types/models/entreprise-custom-data-setting'
import { EntrepriseCustomDataSettingCible } from '../../../types/records/entreprise-custom-data-type-record'

/** Champs de l'entreprise qui portent sur ses courses, définitions sans valeur encore saisie. */
export const champsPersonnalisesCourse = (
  settings: EntrepriseCustomDataSetting[] | undefined,
): EntrepriseCustomDataSetting[] =>
  (settings ?? []).filter((setting) => setting.cible === EntrepriseCustomDataSettingCible.Course)

type CourseCustomDataSectionProps = {
  /** Tous les champs de l'entreprise facturée : la section ne garde que ceux des courses. */
  settings: EntrepriseCustomDataSetting[] | undefined
  values: Record<string, string>
  onChange?: (values: Record<string, string>) => void
  readOnly?: boolean
}

/**
 * Champs que l'entreprise facturée veut voir renseignés sur chacune de ses réservations —
 * numéro de dossier, centre de coût… Rien à afficher pour une course sans entreprise, ou pour
 * une entreprise qui n'en a défini aucun.
 */
export const CourseCustomDataSection = ({
  settings,
  values,
  onChange,
  readOnly = false,
}: CourseCustomDataSectionProps) => {
  const t = useTranslations('custom_data')
  const champs = champsPersonnalisesCourse(settings)

  if (champs.length === 0) return null

  return (
    <Section titre={t('section_title')} icon="add_notes">
      <CustomDataValues
        settings={champs}
        values={values}
        onChange={onChange}
        readOnly={readOnly}
        titre={t('to_be_filled')}
      />
    </Section>
  )
}
